"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flow = void 0;
const typeorm_1 = require("typeorm");
const flow_lang_1 = require("./flow-lang");
const form_flow_1 = require("./form-flow");
const order_form_question_1 = require("./order-form-question");
let Flow = class Flow {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], Flow.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Flow.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Flow.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => flow_lang_1.FlowLang, (item) => item.flow, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Flow.prototype, "translations", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => order_form_question_1.OrderFormQuestion, (item) => item.flow, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Flow.prototype, "orderFormQuestions", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => form_flow_1.FormFlow, (formFlow) => formFlow.flow, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], Flow.prototype, "formFlowSet", void 0);
Flow = __decorate([
    (0, typeorm_1.Entity)('flow', { schema: 'order_intake_forms' })
], Flow);
exports.Flow = Flow;
//# sourceMappingURL=flow.js.map